import React from "react";
import Navbar from "../../components/navbar/Navbar";
import { Box } from "@mui/material";
import AboutUs from "../../components/aboutus/aboutUs";
import Footer from "../../components/Footer/Footer";

const ContactUsPage = () => {
  return (
    <Box>
      <Navbar />
      <AboutUs />
      <Footer />
    </Box>
  );
};

export default ContactUsPage;